export const pagesSalaryAndWagesEn = {
  alerts: {
    actions: {
      exportToastDescription: 'Export is not available in the demo.',
      exportToastTitle: 'Export'
    },
    columns: {
      affectedPeriod: 'Affected period',
      alert: 'Alert',
      detectedAt: 'Detected',
      dueDate: 'Due',
      member: 'Member',
      organization: 'Organization',
      payrollStructure: 'Payroll structure',
      severity: 'Severity'
    },
    detail: {
      affectedPeriod: 'Affected period',
      assumptions: 'Assumptions',
      baselineValue: 'Baseline',
      close: 'Close',
      criteria: 'Criteria',
      currentValue: 'Current',
      detectedAt: 'Detected',
      directReason: 'Why this alert fired',
      dueOverdue_one: '{{count}} day overdue',
      dueOverdue_other: '{{count}} days overdue',
      dueRemaining_one: '{{count}} day left',
      dueRemaining_other: '{{count}} days left',
      dueToday: 'Due today',
      escalation: 'Escalation and resolution',
      establishment: 'Establishment',
      forecastConfidence: 'Forecast confidence',
      forecastValue: 'Forecast',
      formula: 'Formula',
      judgedPeriods: 'Pay periods used',
      metrics: 'Details to review',
      nextEvaluationAt: 'Next evaluation',
      organization: 'Organization',
      payrollStructure: 'Payroll structure',
      purpose: 'What this alert tells you',
      recommendedActions: 'Recommended actions',
      requiredData: 'Data used',
      resolvedAt: 'Resolved at',
      ruleVersion: 'Rule version',
      sections: {
        about: 'About this alert',
        judgment: 'Basis of judgment',
        target: 'Subject and period',
        values: 'Current, baseline and forecast'
      },
      subject: 'Subject',
      thresholds: 'Thresholds',
      triggerTimings: 'Trigger timings'
    },
    empty: 'No alerts match the current filters.',
    error: 'Failed to load alerts.',
    items: {
      minimumWageShortfall: 'Minimum wage shortfall expected',
      negativeNetPay: 'Negative net pay or uncollectible deduction expected',
      netPayDrop: 'Large net pay decrease expected',
      payrollBudgetOverrun: 'Payroll total or funding over budget',
      payrollItemExpiry: 'Earning or deduction item expiring',
      retroactiveCalculation: 'Retroactive calculation required',
      socialInsuranceRevision: 'Possible social insurance revision (monthly remuneration change)',
      yearEndAdjustmentDelta: 'Large year-end adjustment shortfall or refund expected'
    },
    organizationScope: 'Organization-wide',
    resolvedBadge: 'Resolved',
    searchPlaceholder: 'Search by subject, organization or alert',
    severity: {
      error: 'Error',
      warning: 'Warning'
    },
    severityDescription: {
      error: 'Finalized information, including future-dated changes, makes a legal violation, unpaid amount, payment shortfall or missed filing a reasonable conclusion. Finalizing or paying the target month while this is open is not recommended.',
      warning: 'Past trends or unconfirmed future information indicate that action may become necessary. Processing need not stop, but review, planning and employee notice are recommended.'
    },
    title: 'Alerts',
    valueKind: {
      confirmed: 'Confirmed',
      estimated: 'Estimated',
      scheduled: 'Scheduled'
    }
  },
  contractAndCost: {
    chart: {
      cost: {
        helpTooltip: 'Monthly gross pay, employer contributions, and total labor cost, based on payment date.',
        title: 'Labor cost trend'
      },
      payment: {
        helpTooltip: 'Monthly gross pay, deductions, and net pay, based on payment date.',
        title: 'Pay trend'
      }
    },
    empty: {
      subtitle: 'No pay was recorded in the selected 12-month window.',
      title: 'No records for this period'
    },
    grid: {
      entityHeader: {
        department: 'Department',
        member: 'Employee'
      },
      item: 'Item',
      loadError: 'Failed to load.',
      total: 'Total',
      trend: 'Trend'
    },
    rows: {
      employerContribution: 'Employer',
      grossAmount: 'Gross',
      netAmount: 'Net pay',
      totalDeductions: 'Deductions',
      totalLaborCost: 'Labor cost'
    },
    statCards: {
      comparison: {
        PREVIOUS_MONTH: 'MoM',
        PREVIOUS_YEAR: 'YoY'
      },
      cost: {
        employerContribution: 'Employer contributions',
        employerContributionTooltip: "The employer's share of social insurance and other statutory contributions.",
        grossAmount: 'Gross pay',
        grossAmountTooltip: 'Total earnings before deductions, including bonuses.',
        periodTotal: 'Labor cost (12 months)',
        totalLaborCost: 'Total labor cost',
        totalLaborCostTooltip: 'Gross pay plus employer contributions — what the company actually bears.'
      },
      headcount: '{{count}} employees',
      latestMonth: 'As of {{month}}',
      noData: '–',
      payment: {
        grossAmount: 'Gross pay',
        grossAmountTooltip: 'Total earnings before deductions, including bonuses.',
        netAmount: 'Net pay',
        netAmountTooltip: 'Gross pay minus deductions — the amount actually paid to employees.',
        periodTotal: 'Net pay (12 months)',
        totalDeductions: 'Deductions',
        totalDeductionsTooltip: 'Statutory deductions (tax, social insurance) plus agreed deductions.'
      }
    }
  },
  employeeDetail: {
    bonusEmpty: 'No bonus pay slips for this employee.',
    empty: 'No pay slips for this employee.',
    files: {
      actions: {
        back: 'Back',
        delete: 'Delete',
        deleteToastDescription: 'Delete is not available in the demo.',
        deleteToastTitle: 'Delete',
        download: 'Download',
        downloadToastDescription: 'Download is not available in the demo.',
        downloadToastTitle: 'Download',
        openFolder: 'Open {{folderName}}',
        previewToastDescription: 'Preview is not available in the demo.',
        previewToastTitle: 'Preview',
        rename: 'Rename',
        renameToastDescription: 'Rename is not available in the demo.',
        renameToastTitle: 'Rename'
      },
      columns: {
        fileCount: 'Files',
        fileName: 'File name',
        folder: 'Folder',
        updatedAt: 'Updated'
      },
      folders: {
        bonus: 'Bonus statements',
        payslip: 'Pay slips',
        yearEndAdjustment: 'Year-end adjustment'
      },
      title: 'Files'
    },
    history: {
      addComparison: 'Add comparison',
      categories: {
        attendance: 'Attendance & basis',
        earnings: 'Earnings',
        result: 'Results',
        social_insurance: 'Social insurance',
        tax: 'Tax'
      },
      collapsePayItemLines: 'Collapse breakdown for {{label}}',
      columnLabels: {
        variable: 'Variable / category'
      },
      currentBadge: 'Current',
      emptyNoSnapshots: 'No calculation history for this month.',
      expandPayItemLines: 'Expand breakdown for {{label}}',
      records: {
        columns: {
          calcLogicVersion: 'Calc Logic',
          finalizedAt: 'Finalized At',
          finalizedBy: 'Finalized By',
          period: 'Period',
          recordNumber: 'Record No.',
          revisionNumber: 'Revision',
          source: 'Source',
          status: 'Status',
          updatedAt: 'Updated At'
        },
        empty: 'No pay slip history for this employee.'
      },
      searchAriaLabel: 'Search calculation history',
      searchPlaceholder: 'Find history…',
      showChangesOnly: 'Show only changes'
    },
    tabs: {
      alerts: 'Alerts',
      bonusPaySlipList: 'Bonus pay slips',
      files: 'Files',
      history: 'History',
      overview: 'Overview',
      paySlipList: 'Pay slips',
      payslip: 'Pay slip',
      settings: 'Settings',
      wageLedger: 'Wage ledger',
      withholdingSlipList: 'Withholding slips'
    },
    tabsAriaLabel: 'Employee pay slip sections',
    toolbar: {
      compare: 'Compare',
      compareToastDescription: 'Comparison is not available in the demo.',
      compareToastTitle: 'Compare',
      download: 'Download',
      downloadToastDescription: 'Download is not available in the demo.',
      downloadToastTitle: 'Download',
      noResults: 'No pay slips match the search.',
      searchPlaceholder: 'Search by slip number or period'
    },
    wageLedgerEmpty: 'No wage ledger entries for this employee.',
    withholdingEmpty: 'No withholding slips for this employee.'
  },
  enums: {
    lineType: {
      accrual: 'Accrual',
      deduction: 'Deduction',
      earning: 'Earning',
      employerContribution: 'Employer Contribution',
      memo: 'Memo'
    },
    paymentAllocationRule: {
      fixedAmount: 'Fixed',
      remainder: 'Remainder'
    },
    paymentMethod: {
      bankTransfer: 'Bank transfer',
      cash: 'Cash'
    },
    recordSource: {
      engine: 'Engine',
      import: 'Import',
      manual: 'Manual'
    },
    runType: {
      bonus: 'Bonus',
      offCycle: 'Off-cycle',
      regular: 'Regular',
      retro: 'Retroactive',
      termination: 'Termination',
      yearEndAdj: 'Year-end Adjustment'
    },
    status: {
      approving: 'Approving',
      calculated: 'Calculated',
      calculating: 'Calculating',
      cancelled: 'Cancelled',
      delivered: 'Delivered',
      draft: 'Draft',
      finalized: 'Calculation completed',
      paid: 'Paid'
    }
  },
  pageTitle: 'Salary & Wages',
  recordDetail: {
    /** Action menu in the detail panel header. Demo shows a toast instead of acting */
    actions: {
      deliver: 'Deliver',
      deliverToastDescription: 'Delivery is not available in the demo.',
      deliverToastTitle: 'Deliver',
      download: 'Download',
      downloadToastDescription: 'Download is not available in the demo.',
      downloadToastTitle: 'Download'
    },
    amountSummary: {
      accrualTotal: 'Accruals',
      employerContributionTotal: 'Employer Contribution',
      grossAmount: 'Gross Amount',
      mismatchWarning: 'Header totals disagree with line totals on: {{fields}}. Do not treat this record as reliable.',
      mismatchWarningBadge: 'Mismatch',
      netAmount: 'Net Amount',
      totalDeductions: 'Total Deductions',
      totalLaborCost: 'Total Labor Cost'
    },
    attendance: {
      amendedWarning: 'Attendance for this record was amended after the period was closed. Verify whether a retroactive difference needs to be issued.',
      amendedWarningBadge: 'Amended after close',
      days: {
        absenceDays: 'Absence days',
        daysWorked: 'Days worked',
        legalHolidayWorkdays: 'Legal holiday workdays',
        paidLeaveDays: 'Paid leave days',
        restDayWorkdays: 'Rest day workdays',
        scheduledWorkdays: 'Scheduled workdays',
        title: 'Days',
        totalWorkdays: 'Total workdays',
        unpaidLeaveDays: 'Unpaid leave days'
      },
      hours: {
        earlyLeaveHours: 'Early leave hours',
        hourlyBasisHours: 'Hourly rate basis hours',
        lateHours: 'Late hours',
        legalHolidayHours: 'Legal holiday hours',
        nightHours: 'Night hours',
        otOver60h: 'OT over 60h/month',
        restDayHours: 'Rest day hours',
        scheduledWorkHours: 'Scheduled work hours',
        statutoryOtOver: 'Statutory OT (over)',
        statutoryOtWithin: 'Statutory OT (within)',
        title: 'Hours',
        totalWorkHours: 'Total work hours'
      },
      traceability: {
        aeBatchRef: 'AE Batch Ref.',
        amendedFlag: 'Amended After Close',
        amendedFlagNo: 'No',
        amendedFlagYes: 'Yes',
        attendanceFinalizedAt: 'Attendance Finalized At',
        title: 'Upstream Traceability',
        workingTimeScheme: 'Working Time Scheme'
      },
      /** Unit suffix for the Value column; differs between the day and hour blocks */
      units: {
        day: 'days',
        hour: 'hours'
      },
      weeklyOtBreakdown: {
        columns: {
          otHours: 'OT Hours',
          weekStart: 'Week Start',
          workHours: 'Work Hours'
        },
        note: 'Under US FLSA, overtime is determined per calendar workweek, not per pay period. Even in a semi-monthly payroll, overtime is recalculated at each week boundary — this is why this breakdown only appears for US records.',
        title: 'Weekly Overtime Breakdown'
      }
    },
    error: 'Failed to load the salary record.',
    header: {
      calcLogicVersion: 'Calc Logic',
      calculationPeriod: 'Calculation Period',
      department: 'Department',
      employeeCode: 'Employee No.',
      employeeName: 'Name',
      finalizedAt: 'Finalized At',
      finalizedBy: 'Finalized By',
      issueDate: 'Issue Date',
      lockedBadge: 'Finalized · Locked',
      paymentDate: 'Payment Date',
      payrollRunId: 'Payroll Run',
      rateMasterVersion: 'Rate Master',
      recordNumber: 'Record No.',
      revisionNumber: 'Revision'
    },
    lineAbsenceNote: 'Negative earning shown here (absence adjustment)',
    /** Distribution of net pay across payees (E5) */
    paymentAllocation: {
      /** Reads as "Barclays Shoreditch Branch · ****7126" */
      accountSummary: '{{bank}} {{branch}} · {{account}}',
      mismatchWarning: 'Allocated total {{allocated}} does not match net pay {{netAmount}}. Verify that no payment was dropped.',
      mismatchWarningBadge: 'Allocation mismatch',
      /** Reads as "Bank transfer (Remainder)" */
      rowLabel: '{{method}} ({{rule}})'
    },
    sections: {
      attendance: 'Attendance',
      paymentAllocation: 'Transfer',
      postTax: 'Post-tax',
      preTax: 'Pre-tax',
      totals: 'Totals'
    },
    table: {
      amount: 'Amount',
      itemCode: 'Code',
      itemName: 'Pay slip item',
      /** Change vs the immediately preceding pay run (previous month for salary, previous run for bonus) */
      previousDelta: 'vs previous',
      quantity: 'Qty',
      rate: 'Rate',
      /** Header for a column mixing money, hours and days */
      value: 'Value'
    }
  },
  reports: {
    categories: {
      individual: 'Individual',
      organization: 'Organization'
    },
    columns: {
      collectedTax: 'Collected Tax',
      deductions: 'Deductions',
      dueDate: 'Due Date',
      employee: 'Employee',
      employerContribution: 'Employer Cost',
      gross: 'Gross',
      headcount: 'Headcount',
      issueDate: 'Issue Date',
      monthsCovered: 'Months',
      net: 'Net',
      nontaxableGross: 'Non-taxable',
      office: 'Office',
      paidAmount: 'Paid Amount',
      period: 'Period',
      recordNumber: 'Record No.',
      socialInsurance: 'Social Insurance',
      status: 'Status',
      targetMonth: 'Target Month',
      targetPeriod: 'Target Period',
      taxYear: 'Year',
      taxableGross: 'Taxable',
      totalLaborCost: 'Total Labor Cost',
      withheldTax: 'Withheld Tax'
    },
    empty: 'No data for this report.',
    error: 'Failed to load the report.',
    names: {
      bonusPayslip: 'Bonus Payslip',
      incomeTaxStatement: 'Statement of Collected Income Tax',
      laborInsuranceDeclaration: 'Labour Insurance Annual Declaration',
      payslip: 'Payslip',
      residentTaxStatement: 'Resident Tax Payment Breakdown',
      retirementWithholdingSlip: 'Retirement Income Withholding Tax Certificate',
      salaryPaymentReport: 'Salary Payment Report (Summary)',
      standardRemunerationNotification: 'Standard Remuneration Calculation Notification',
      statutoryReportSummary: 'Summary of Statutory Reports',
      wageLedger: 'Wage Ledger',
      withholdingSlip: 'Withholding Tax Certificate'
    },
    searchPlaceholder: 'Search…',
    sidebar: {
      close: 'Close sidebar',
      open: 'Open sidebar',
      title: 'Statutory reports'
    },
    wageLedger: {
      bookColumns: {
        deductionTotal: 'Deductions Total',
        grossAmount: 'Gross Pay',
        netAmount: 'Net Pay',
        organization: 'Establishment',
        period: 'Covered Period',
        recordCount: 'Records',
        updatedAt: 'Last Updated',
        year: 'Year'
      },
      columns: {
        absenceDays: 'Absence Days',
        absenceDeduction: 'Absence Deduction',
        baseSalary: 'Base Salary',
        birthDate: 'Date of Birth',
        bonus: 'Bonus',
        childCareSupport: 'Child Care Support Levy',
        childCareSupportRetirementMonth: 'Child Care Support Levy (Retirement Month)',
        commuteAllowance: 'Commuting Allowance',
        daysWorked: 'Days Worked',
        deductionTotal: 'Deductions Total',
        deemedOtAllowance: 'Deemed Overtime Allowance',
        deemedOtExcessAllowance: 'Deemed Overtime Excess Allowance',
        employeeCode: 'Employee No.',
        employmentInsurance: 'Employment Insurance',
        executiveRemuneration: 'Executive Remuneration',
        expenseReimbursement: 'Expense Reimbursement',
        fixedOtAmount: 'Fixed Overtime Amount',
        fixedPeriodEnd: 'Period End (Fixed Pay)',
        fixedPeriodStart: 'Period Start (Fixed Pay)',
        gender: 'Gender',
        grossAmount: 'Gross Pay',
        healthInsurance: 'Health Insurance',
        healthInsuranceRetirementMonth: 'Health Insurance (Retirement Month)',
        healthInsuranceStandardRemuneration: 'Standard Monthly Remuneration (Health Ins.)',
        incomeTax: 'Income Tax',
        lateEarlyDeduction: 'Late / Early Leave Deduction',
        lateEarlyHours: 'Late / Early Leave',
        legalHolidayAllowance: 'Statutory Holiday Allowance',
        legalHolidayHours: 'Statutory Holiday Hours',
        longTermCare: 'Long-Term Care Insurance',
        longTermCareRetirementMonth: 'Long-Term Care Insurance (Retirement Month)',
        monthlyTaxCut: 'Monthly Fixed Tax Reduction',
        netAmount: 'Net Pay',
        nightAllowance: 'Night Allowance',
        nightHours: 'Night Hours',
        nontaxableCommute: 'Non-taxable Commuting Allowance',
        nontaxableCommuteFixed: 'Non-taxable Commuting (Fixed)',
        nontaxableCommuteVariable: 'Non-taxable Commuting (Variable)',
        nontaxableGrossTotal: 'Non-taxable Earnings Total',
        otOver60Allowance: 'Overtime Allowance (Over 60h)',
        otOver60Hours: 'Overtime Hours Over 60h',
        otWithinAllowance: 'OT Allowance (Within Statutory)',
        over45hAllowance: 'Allowance Over 45h',
        overtimeAllowance: 'Overtime Allowance',
        overtimeHours: 'Overtime Hours',
        payBasis: 'Pay Basis',
        paymentDate: 'Payment Date',
        pension: 'Employees’ Pension Insurance',
        pensionRetirementMonth: 'Employees’ Pension Insurance (Retirement Month)',
        pensionStandardRemuneration: 'Standard Monthly Remuneration (Pension)',
        premiumActualTotal: 'Premium Pay (Actual) Total',
        premiumTotal: 'Premium Pay Total',
        previousMonthAdjustment: 'Previous Month Adjustment',
        residentTax: 'Resident Tax',
        retroAllowance: 'Retroactive Allowance',
        runType: 'Run Type',
        scheduledWorkHours: 'Scheduled Hours',
        shortHours: 'Shortfall Hours',
        shortHoursDeduction: 'Shortfall Hours Deduction',
        socialInsuranceAdjustment: 'Social Insurance Adjustment Allowance',
        socialInsuranceTotal: 'Social Insurance Deductions Total',
        statutoryOtWithinHours: 'OT Hours Within Statutory',
        taxableBase: 'Taxable Base',
        taxableCommute: 'Taxable Commuting Allowance',
        taxableCommuteFixed: 'Taxable Commuting (Fixed)',
        taxableCommuteVariable: 'Taxable Commuting (Variable)',
        taxableGrossTotal: 'Taxable Earnings Total',
        totalWorkHours: 'Total Worked Hours',
        travelSettlement: 'Travel Expense Settlement',
        variablePeriodEnd: 'Period End (Variable Pay)',
        variablePeriodStart: 'Period Start (Variable Pay)',
        yearEndCollection: 'Year-End Adjustment Collected',
        yearEndRefund: 'Year-End Adjustment Refund',
        yearEndSettlement: 'Year-End Adjustment Settlement'
      },
      detail: {
        breakdown: 'Pay periods',
        error: 'Failed to load the wage ledger.',
        total: 'Ledger total'
      },
      /** 時間の列は「時間」「分」に分けて記載する。ラベルは共通の語幹から組む */
      hoursUnit: '{{label}} (h)',
      minutesUnit: '{{label}} (min)'
    }
  },
  ruleAndPolicy: {
    clause: {
      organizationUnits: {
        addUnit: 'Add organization unit',
        allSubordinates: 'Include subordinate organizations',
        empty: 'No organization units selected',
        exclude: 'Exclude',
        members: 'Members: {{count}}',
        remove: 'Remove {{name}}'
      }
    },
    description: 'Decide which members each payroll structure applies to. Rules are evaluated in order and only the first match applies.',
    detail: {
      saved: 'Assignment rule saved.',
      unassignedNotice: 'This payroll structure has no assignment rule yet. Select the target organizations and member types to create one.'
    },
    groupName: 'Payroll structures',
    loadError: 'Failed to load assignment rules.',
    ruleName: 'Assignment rule',
    sideTab: {
      assignmentRules: 'Assignment Rules',
      closeSideTab: 'Close side tab',
      payrollStructures: 'Payroll structures'
    },
    table: {
      columns: {
        description: 'Description',
        memberCount: 'Worker Total',
        order: 'Order',
        structureName: 'Payroll structure'
      },
      searchPlaceholder: 'Search by payroll structure',
      unassigned: 'Not configured'
    }
  },
  settings: {
    establishments: {
      add: 'Add establishment',
      columns: {
        handle: 'Reorder',
        name: 'Establishment',
        orgUnits: 'Organizations',
        period: 'Effective period',
        places: 'Places'
      },
      description: 'An establishment is the unit that labor standards and occupational safety law apply to. Combine places and organizations so that every employee belongs to an establishment.\nEach employee is assigned to the first establishment that matches, evaluated from the top.',
      editor: {
        createTitle: 'Add establishment',
        discardConfirm: 'Discard your changes?',
        discardConfirmCancel: 'Keep editing',
        discardConfirmOk: 'Discard',
        editTitle: 'Edit: {{name}}',
        orgUnitTree: {
          addUnit: 'Add organization unit',
          allSubordinates: 'All subordinate units',
          collapse: 'Collapse',
          expand: 'Expand',
          removeUnit: 'Remove organization unit',
          removeUnitAriaLabel: 'Remove {{name}} from the tree'
        },
        saveCreate: 'Create establishment',
        saveUpdate: 'Save',
        savedToast: 'Saved',
        sections: {
          basic: 'Basic information',
          orgUnits: 'Organization scope',
          places: 'Location scope'
        },
        tabs: {
          basic: 'Details',
          obligations: 'Statutory requirement',
          preview: 'Applicable employees'
        },
        unassignConfirmCancel: 'Cancel',
        unassignConfirmMessage_one: 'This change leaves {{count}} employee unassigned.',
        unassignConfirmMessage_other: 'This change leaves {{count}} employees unassigned.',
        unassignConfirmOk: 'Save anyway',
        unassignConfirmTitle: 'Confirm the change'
      },
      empty: {
        addManually: 'Add manually',
        createFromPlaces: 'Generate candidates',
        description: 'No establishments yet. You can generate candidates from your places.'
      },
      error: {
        retry: 'Reload',
        title: 'Could not load establishments.'
      },
      filters: {
        searchPlaceholder: 'Search by name or code'
      },
      fields: {
        includeDescendants: {
          help: 'Employees in descendant organizations are also included.',
          label: 'Include descendant organizations'
        },
        industryClass: {
          label: 'Industry class'
        },
        laborStandardsOffice: {
          label: 'Labor standards inspection office',
          placeholder: 'Select an office'
        },
        locationPlace: {
          label: 'Location',
          required: 'Select a location.'
        },
        name: {
          label: 'Name',
          required: 'Enter a name.',
          tooLong: 'Use 64 characters or fewer.'
        },
        orgUnits: {
          label: 'Organizations',
          placeholder: 'Select organizations'
        },
        period: {
          label: 'Effective period',
          separator: '–'
        },
        periodEnd: {
          placeholder: 'Select an end date'
        },
        periodStart: {
          label: 'Start date',
          required: 'Enter a start date.'
        },
        places: {
          clearAll: 'Clear all places',
          headcountSuffix: '{{count}} on site',
          label: 'Places',
          mergedHint: 'More than one place is referenced. This is a merge exception, so a scope rationale is required.',
          noResults: 'No results found',
          searchPlaceholder: 'Search places...',
          usedBy: 'Used by {{name}}'
        },
        removeSelection: 'Remove {{name}}',
        scopeRationale: {
          help: 'Explain the merge or split so it can be shown to the inspection office.',
          label: 'Scope rationale',
          placeholder: 'e.g. The Nagoya office has 4 permanent staff and no HR or payroll authority, so it is merged into the head office.',
          requiredOnMerge: 'A rationale is required when more than one place is referenced.'
        },
        selectedCount: '{{count}} selected',
        sourceEmpty: 'Select at least one place or organization.'
      },
      industryClass: {
        groupA: 'Group A (construction, mining, transport)',
        groupB: 'Group B (manufacturing, utilities, retail)',
        groupC: 'Group C (other industries)'
      },
      obligations: {
        appointments: '{{count}} or more required',
        headcount: 'Regular employees (as of the reference date)',
        minimumWage: 'Applicable regional minimum wage',
        nearThreshold: '{{count}} more employees until this applies',
        notApplicableIndustry: 'Not applicable to {{industry}}',
        notRequired: 'Not required',
        required: 'Required',
        threshold: '{{count}} or more',
        titles: {
          exclusivePhysician: 'Full-time industrial physician',
          generalSafetyManager: 'General safety and health manager',
          healthCommittee: 'Health committee',
          healthOfficer: 'Health officer',
          industrialPhysician: 'Industrial physician',
          safetyOfficer: 'Safety officer',
          stressCheck: 'Stress check',
          workRules: 'Work rules filing'
        }
      },
      override: {
        establishment: 'Establishment',
        note: 'Note',
        reason: 'Reason',
        reasons: {
          concurrent: 'Concurrent post',
          other: 'Other',
          secondment: 'Secondment',
          telework: 'Telework'
        },
        removedToast: 'Assignment added',
        title: 'Assign individually',
        undo: 'Undo'
      },
      period: {
        ended: 'Ended',
        future: 'Starts in the future',
        openEnded: '{{start}} –',
        range: '{{start}} – {{end}}'
      },
      preview: {
        calculating: 'Calculating…',
        columns: {
          name: 'Name',
          orgUnit: 'Organization',
          place: 'Place',
          status: 'Status'
        },
        noDiff: 'No change in assignment',
        noMembers: 'No employees match this definition.',
        noSource: 'Select a source to see the preview.',
        reviewSource: 'Review the source',
        statusAdded: 'Will be added on save',
        statusNotApplicable: 'Covered by a higher-priority establishment',
        statusRemoved: 'Will be removed on save',
        summary: {
          diff: 'Change since the last save',
          diffValue: '+{{added}} / −{{removed}}',
          headcount: 'Applicable employees',
          notApplicable: 'Covered by a higher-priority establishment'
        }
      },
      reorder: {
        announce: 'Moved {{name}} to position {{position}}',
        cancel: 'Cancel',
        disabledHint: 'Clear the filters to change the order. Reordering needs the full list.',
        grabAriaLabel: 'Reorder {{name}}',
        grabbed: 'Grabbed {{name}}. Use the arrow keys to move it.',
        hint: 'Evaluated from the top. The first match wins.',
        save: 'Save order',
        savedToast: 'Order saved'
      },
      source: {
        more: '+{{count}}',
        none: '–',
        withDescendants: 'incl. descendants'
      },
      title: 'Establishments',
      unassigned: {
        actions: {
          createEstablishment: 'Create an establishment for this place',
          mergeIntoExisting: 'Merge into an existing establishment',
          overrideIndividually: 'Assign individually',
          snooze: 'Handle later'
        },
        backToRegistry: 'Back to establishments',
        causeHelp: {
          establishmentOutOfPeriod: 'The establishment that used to cover this place has ended. Extend its period or move the place to another establishment.',
          noWorkPlace: 'A home address is not an establishment. Choose the establishment these employees belong to. The applicable minimum wage follows that establishment’s location.',
          placeNotReferenced: 'Merge this place into an existing establishment, or create a new establishment for it.',
          secondment: 'Assign these employees individually so their working hours are managed by the right establishment.'
        },
        causes: {
          establishmentOutOfPeriod: 'The referencing establishment is outside its effective period',
          noWorkPlace: 'No work location set',
          placeNotReferenced: 'The work location does not belong to any establishment',
          secondment: 'On secondment'
        },
        emptyTitle: 'Every employee is assigned to an establishment.',
        selectEmployee: 'Select an employee to resolve.',
        title: 'Resolve assignments'
      },
      validation: {
        missingAttribute: 'Attributes missing',
        noMember: 'No members',
        ok: 'Normal',
        outOfPeriod: 'Out of period',
        shadowed: 'Higher-priority establishment applies',
        shadowedDetail_one: '{{count}} employee is covered by a higher-priority establishment',
        shadowedDetail_other: '{{count}} employees are covered by a higher-priority establishment',
        showOutOfPeriod: 'Show out of effective period'
      }
    },
    navigation: {
      establishments: 'Establishments',
      label: 'Settings menu',
      paySlips: 'Pay slips'
    },
    paySlips: {
      add: 'Add pay slip',
      columns: {
        name: 'Pay slip name',
        period: 'Effective period',
        structures: 'Payroll structures'
      },
      description: 'A pay slip definition decides which items are printed on the statement and under which names.\nLink it to the payroll structures that should use it.',
      editor: {
        addItem: 'Add item',
        createTitle: 'Add pay slip',
        discardConfirm: 'Discard your changes?',
        discardConfirmCancel: 'Keep editing',
        discardConfirmOk: 'Discard',
        editTitle: 'Edit: {{name}}',
        emptySection: 'No items in this category.',
        itemColumns: {
          handle: 'Reorder',
          label: 'Pay slip item name',
          payrollItem: 'Payroll item',
          remove: 'Remove'
        },
        labelPlaceholder: 'Name printed on the statement',
        payrollItem: {
          noResults: 'No payroll items found',
          none: 'Not linked',
          placeholder: 'Select a payroll item',
          searchPlaceholder: 'Search payroll items...'
        },
        removeItemAriaLabel: 'Remove {{name}}',
        reorder: {
          announce: 'Moved {{name}} to position {{position}}',
          grabAriaLabel: 'Reorder {{name}}',
          grabbed: 'Grabbed {{name}}. Use the arrow keys to move it.',
          hint: 'Items are printed top to bottom. Reordering stays inside a category.'
        },
        saveCreate: 'Create pay slip',
        saveUpdate: 'Save',
        savedToast: 'Saved',
        sections: {
          basic: 'Basic information',
          header: 'Header'
        },
        tabs: {
          detail: 'Details',
          items: 'Items',
          preview: 'Document style preview'
        }
      },
      empty: {
        addManually: 'Add manually',
        description: 'No pay slips yet.'
      },
      error: {
        retry: 'Reload',
        title: 'Could not load pay slips.'
      },
      filters: {
        searchPlaceholder: 'Search by name'
      },
      /** 宛先ブロックの固定フィールド名。新規作成時の項目名の初期値にも使う */
      headerFields: {
        calculationPeriod: 'Pay period',
        department: 'Department',
        employeeCode: 'Employee number',
        employeeName: 'Name',
        establishment: 'Establishment',
        paymentDate: 'Payment date'
      },
      fields: {
        name: {
          label: 'Name',
          required: 'Enter a name.',
          tooLong: 'Use 64 characters or fewer.'
        },
        payrollStructures: {
          label: 'Payroll structures',
          placeholder: 'Select payroll structures',
          required: 'Select at least one payroll structure.'
        },
        period: {
          label: 'Effective period',
          separator: '–'
        },
        periodEnd: {
          beforeStart: 'The end date must be on or after the start date.',
          placeholder: 'Select an end date'
        },
        periodStart: {
          required: 'Enter a start date.'
        }
      },
      period: {
        ended: 'Ended',
        future: 'Starts in the future',
        openEnded: '{{start}} –',
        range: '{{start}} – {{end}}'
      },
      preview: {
        documentTitle: 'Pay Statement',
        download: 'Download PDF',
        downloadToastDescription: 'PDF export is not wired up in this mock yet.',
        downloadToastTitle: 'Download requested',
        issuer: 'DRESS CODE, Inc.',
        sampleNotice: 'Amounts and dates are sample values for checking the layout.',
        samplePlaceholder: 'Sample',
        sampleValues: {
          department: 'People Department',
          employeeCode: 'E-1042',
          employeeName: 'Taro Yamada',
          establishment: 'Head office (Minato)'
        },
        seal: 'Seal',
        /** 勤怠ブロックの値に付ける単位 */
        units: {
          day: 'days',
          hour: 'hours'
        }
      },
      sections: {
        attendance: 'Attendance',
        deduction: 'Deductions',
        earning: 'Earnings',
        total: 'Totals'
      },
      structures: {
        more: '+{{count}}',
        none: '–'
      },
      title: 'Pay slips',
      validation: {
        showOutOfPeriod: 'Show out of effective period'
      }
    },
    title: 'Settings'
  },
  tabs: {
    alerts: 'Alerts',
    contractAndCost: 'Contract & Cost',
    reports: 'Reports',
    ruleAndPolicy: 'Rule & Policy',
    settings: 'Settings'
  }
};